<div class="modelPadding">
	<h5>Note modification</h5>
	<div class="float-main-left">
		<mat-form-field appearance="outline" style="width: 90%">
			<mat-label>Created By</mat-label>
			<input
				[readonly]="true"
				matInput
				type="string"
				[(ngModel)]="commentInfo.created_by"
			/>
		</mat-form-field>
		<mat-form-field appearance="outline" style="width: 90%">
			<mat-label>Created At</mat-label>
			<input
				[readonly]="true"
				matInput
				type="string"
				[(ngModel)]="commentInfo.created_at"
			/>
		</mat-form-field>
		<mat-form-field appearance="outline" style="font-weight: bold; width: 90%">
			<mat-label>Disposition</mat-label>
			<mat-select [(ngModel)]="commentInfo.disposition">
				<mat-option *ngFor="let d of dispositions" [value]="d.name">
					{{ d.id }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>

	<div class="float-main-right">
		<mat-form-field appearance="outline" style="width: 90%">
			<mat-label>Last Modified By</mat-label>
			<input
				[readonly]="true"
				matInput
				type="string"
				[(ngModel)]="commentInfo.last_modified_by"
			/>
		</mat-form-field>
		<mat-form-field appearance="outline" style="width: 90%">
			<mat-label>Last Modified At</mat-label>
			<input
				[readonly]="true"
				matInput
				type="string"
				[(ngModel)]="commentInfo.last_modified_at"
			/>
		</mat-form-field>
		<mat-form-field appearance="outline" style="font-weight: bold">
			<mat-label>Comment Type</mat-label>
			<mat-select [(ngModel)]="commentInfo.type">
				<mat-option *ngFor="let ct of comment_types" [value]="ct.value">
					{{ ct.viewValue }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
	<mat-form-field appearance="outline" style="width: 100%">
		<textarea
			matInput
			style="margin-top: 10px; width: 100%"
			name="Comments"
			placeholder="Comments"
			rows="5"
			[(ngModel)]="commentInfo.comment"
		></textarea>
	</mat-form-field>
	<br />
	<button mat-raised-button color="warn"  (click)="deleteComment()" style="margin-right: 1.5em;">Delete</button>
	<button mat-raised-button color="primary" (click)="updateComment()">Update</button>
</div>
